import { FC, memo } from 'react';
import Text from '@/components/cms/Text';
import RichText from '@/components/cms/RichText';
import Button from '@/components/ui/Buttons/Button';

type ComponentFallbackProps = {
  heading?: string;
  body?: string;
  buttonLabel?: string;
  buttonClasses?: string;
  isRetrying?: boolean;
  onButtonClick?: () => void;
};

const ComponentFallback: FC<ComponentFallbackProps> = memo(
  ({ heading, body, buttonLabel, buttonClasses, isRetrying, onButtonClick }) => {
    return (
      <>
        <div className="flex w-full flex-col items-start justify-start">
          {!!heading && (
            <Text element="h3" propertyName="Heading" className="heading-3 mb-3 w-full">
              {heading}
            </Text>
          )}
          {!!body && (
            <RichText
              content={body}
              propertyName="Body"
              className="text-2 mb-6 w-full text-gray-dark"
            />
          )}
        </div>
        {!!buttonLabel && (
          <Button
            type="button"
            color="outline-gray"
            className={buttonClasses ?? ''}
            label={buttonLabel}
            loading={isRetrying}
            onClick={onButtonClick}
          />
        )}
      </>
    );
  }
);

export default ComponentFallback;
